import PreorderProduct from '../../models/PreorderProduct'
import { ApiState } from '../../utils/requestAction'
import requestReducer from '../requestReducer'

export interface PreorderSurplusProductState extends ApiState {
  preorderSurplusProducts?: PreorderProduct[] 
}

export default requestReducer<PreorderSurplusProductState>('PREORDER_SURPLUS_PRODUCT')
